window._ = require("lodash");

window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

import "lazysizes";
import sal from "sal.js";

window.Vue = require("vue").default;

Vue.prototype.svg = require("./svg");

const files = require.context("./", true, /\.vue$/i);
files.keys().map(key =>
    Vue.component(
        key
            .split("/")
            .pop()
            .split(".")[0],
        files(key).default
    )
);

import anchorEvents from "@/mixins/root/anchor-events";
import mobileNavigation from "@/mixins/root/mobile-navigation";

export const bus = new Vue();

import VueSocialSharing from 'vue-social-sharing'

Vue.use(VueSocialSharing);

new Vue({
    el: "#app",

    mixins: [anchorEvents, mobileNavigation],

    data: () => ({
        favorites: []
    }),

    mounted() {
        this.favorites = JSON.parse(localStorage.getItem("s2w-favorites") || "[]") || [];
        sal();
    },

    methods: {
        iLikeThis(id) {
            this.favorites = JSON.parse(localStorage.getItem("s2w-favorites") || "[]") || [];
            this.pushOrSlice(this.favorites, id);
            localStorage.setItem("s2w-favorites", JSON.stringify(this.favorites));
        },
        pushOrSlice(array, prop) {
            array.includes(prop) ? array.splice(array.indexOf(prop), 1) : array.push(prop);

            return array;
        }
    }
});
